module.exports = __webpack_public_path__ + "img/dots-vertical-circle-outline.62540d59.svg";